const ActionTypes = {
	request: 'PasswordReset.request',
	receive: 'PasswordReset.receive',
};

export default ActionTypes;
